import React from "react"
import t from "prop-types"
import { Box, Divider, Paper, Typography } from "@material-ui/core"

export default function DocTemplate(props) {
  const { name } = props
  return (
    <Paper style={{ padding: "16px" }}>
      <Typography variant="h2" paragraph>
        Template
      </Typography>
      <Divider />
      <Box p={2}>
        <Typography>Name: {name}</Typography>
        <Typography>
          This is a sample template resolve from a custom UI component.
        </Typography>
      </Box>
    </Paper>
  )
}

DocTemplate.propTypes = {
  name: t.string.isRequired
}
